import { ActionCreator } from '@sendoutcards/core'

export const clearTourId = ActionCreator('CLEAR_TOUR_ID')

export const setTourId = ActionCreator('SET_TOUR_ID', (tourId: string) => ({
  tourId,
}))
